export default (val, base) => {
  let part = Math.floor(val / base);
  return base * part;
}